import inputComponents from './input'
import selectComponents from './select'
import buttonComponents from './button'
import layoutComponents from './layout'
export { default as buttonMerge } from './button/merge'
export { default as inputMerge } from './input/merge'
export { default as selectMerge } from './select/merge'
export * from './layout/merge'

export const initDefaultItems = function(hideList) {
  const list = []
  if (!hideList || !hideList.length || !(hideList === 'LayoutGroup' || hideList.find && hideList.find(hide => hide === 'LayoutGroup'))) {
    list.push({
      label: '布局型组件',
      name: 'LayoutGroup',
      list: layoutComponents(hideList)
    })
  }
  if (!hideList || !hideList.length || !(hideList === 'InputGroup' || hideList.find && hideList.find(hide => hide === 'InputGroup'))) {
    list.push({
      label: '输入型组件',
      name: 'InputGroup',
      list: inputComponents(hideList)
    })
  }
  if (!hideList || !hideList.length || !(hideList === 'SelectGroup' || hideList.find && hideList.find(hide => hide === 'SelectGroup'))) {
    list.push({
      label: '选择型组件',
      name: 'SelectGroup',
      list: selectComponents(hideList)
    })
  }
  if (!hideList || !hideList.length || !(hideList === 'ButtonGroup' || hideList.find && hideList.find(hide => hide === 'ButtonGroup'))) {
    list.push({
      label: '按钮型组件',
      name: 'ButtonGroup',
      list: buttonComponents(hideList)
    })
  }
  return list
}
